import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./pages/Header";
import Showcase from "./showcase/Showcase";
import MainPage from "./pages/main_page/MainPage";
import AboutPage from "./pages/about_us/AboutPage";
import ServicesPage from "./pages/services/ServicesPage";
import ContactsPage from "./pages/contacts/ContactsPage";
import FaqPage from "./pages/faq/FaqPage";
import CasesPage from "./pages/cases/CasesPage";
import PrivacyPolicyPage from "./pages/policy/PrivacyPolicyPage";
import Error404 from "./components/Error404";
import MirrorHero from "./components/MirrorHero";
import ScrollManager from "./components/ScrollManager";
import RelatioCasePage from "./pages/cases/RelatioCasePage";
import DrslCasePage from "./pages/cases/DrslCasePage";
import ChatshopCasePage from "./pages/cases/ChatshopCasePage";
import FuturaCasePage from "./pages/cases/FuturaCasePage";

function App() {
  return (
    <Router>
      <ScrollManager />
      <Header />
      <main className="page-content">
        <Routes>
          {/* Home */}
          <Route path="/" element={<MainPage />} />

          {/* About Us */}
          <Route path="/about" element={<AboutPage />} />

          {/* Services */}
          <Route path="/services" element={<ServicesPage />} />

          {/* Contacts */}
          <Route path="/contacts" element={<ContactsPage />} />

          {/* FAQ */}
          <Route path="/faq" element={<FaqPage />} />

          {/* Cases */}
          <Route path="/cases" element={<CasesPage />} />
          <Route path="/cases/relatio" element={<RelatioCasePage />} />
          <Route path="/cases/drsl" element={<DrslCasePage />} />
          <Route path="/cases/chatshop" element={<ChatshopCasePage />} />
          <Route path="/cases/futura" element={<FuturaCasePage />} />

          {/* Showcase */}
          <Route path="/showcase" element={<Showcase />} />

          {/* Policies */}
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/cookies" element={<Error404 />} />   {/* тимчасово */}
          <Route path="/terms" element={<Error404 />} />

          {/* Thank-you page (після успішної форми) */}
          <Route path="/thank-you" element={<MirrorHero />} />
          
          {/* 404 */}
          <Route path="*" element={<Error404 />} />
        </Routes>
      </main>
    </Router>
  );
}

export default App;
